export default "/institutions/infinitepay.svg";